import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'
// import styles from '../../../assets/styles/componentStyles/viewFacebookIntegration.module.scss'
import { Grid, Typography, useMediaQuery } from '@mui/material'
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
// import IntegrationDetails from './integrationDetails';
import IconsColor from '../../utility/iconsColor';
import GlobalButton from '../../utility/globalButton/button';
import { MetaContext, MetaContextPayload } from '../../../context/metaContext';
import ChatbotFacebookIntegrationSetup from '../../dashboard/chatbot/chatbotFacebookIntegrationSetup';
import { IntegrationContext, IntegrationContextPayload } from '../../../context/integrationContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import { Category, createMetaIntegrationPayloadNew, DataItem, fbLoginResponse, getInstagramAccessTokenResponse, globalIntegration, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../models/axiosModel';
import { checkForErrorCode, FACEBOOK_LOGIN_SCOPE, hasChannelsManageAccess, isAgentOrAdmin, isOrganizationRoleAgent } from '../../../utils/constants';
import FacebookIntegationDetails from './facebookIntegationDetails';
import messengerIcon from '../../../assets/chatbotAssets/facebookMessenger.svg'
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { useIntegrationStore } from '../../../store/integrationStore';


interface checkFlag {
    flagPage?: boolean
}

interface responsePayloadInterface {
    access_token: string,
    page_id: string,
    page_name: string,
    page_category: string,
    page_categoryList: Category[],
}

const ViewFacebookIntegration = (props: checkFlag) => {
    const {
        setShowFacebookIntegrationDetails,
        showFacebookIntegrationDetails,
        metaCredentials,
        GetMetaCredentials
    } = useContext(MetaContext) as MetaContextPayload;

    const {
        getMetaIntegrationList,
        setIntegrationListNewStructure,
        globalIntegrationTypeList,

        // FACEBOOK
        setFacebookIntegrationDetails,
        setIntegrationList,
        integrationListNewStructure

    } = useContext(IntegrationContext) as IntegrationContextPayload;

    const {
        setFlagLoading,
        userDetail,
        handleError, 
        onBoardUser,
        apiRoutesPermissionAssignment
    } = useContext(UserContext) as UserContextPayload;

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const { setFlagIntegrationNotAvailablePopup } = useIntegrationStore((useShallow((state) => ({
        setFlagIntegrationNotAvailablePopup: state.setFlagIntegrationNotAvailablePopup
    }))))

    // CONST
    const navigate = useNavigate()

    const [searchParams, setSearchParams] = useSearchParams()
    const smallScreen = useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)')
    const tabletScreen = useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)')
    const laptopScreen = useMediaQuery<boolean>('(max-width : 1600px) and (min-width : 900px)')

    const [responsePayload, setResponsePayload] = useState<responsePayloadInterface[] | null>(null);


    useLayoutEffect(() => {
        (async () => { 
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            const res = await getMetaIntegrationList(showFacebookIntegrationDetails ? false : true)
            if(!(res.status)){
                handleError(res);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        })()
    }, [])

    useEffect(() => {
        if(metaCredentials){
            loadFacebookSDK();
        }
    }, [metaCredentials]);

    useEffect(() => {
        if (userDetail.flagUser && !isOrganizationRoleAgent(userDetail) && !isAgentOrAdmin(userDetail)) {
            if (!metaCredentials) {
                GetMetaCredentials();
            }
        }
    }, [metaCredentials, userDetail])

    const loadFacebookSDK = () => {
        (function (d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s) as HTMLScriptElement;
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode!.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');

        let fb_init = metaCredentials?.find((configuration) => configuration.channel_name.toLowerCase() == "facebook")?.fb_init
        window.fbAsyncInit = () => {
            window.FB.init(fb_init);
        };
    };

    const isFacebookIntegration = (integration: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew): integration is metaIntegrationFaceBookDataNew => integration.channel_name.toLowerCase() == "facebook";

    useEffect(() => {
        if (searchParams.has('id')) {
            if (integrationListNewStructure && integrationListNewStructure.length > 0) {
                let id = searchParams.get('id')
                let integration = integrationListNewStructure.filter(isFacebookIntegration).find((integration: metaIntegrationFaceBookDataNew) => String(integration.integrated_channel_id) == id)
                if (integration) {
                    setFacebookIntegrationDetails(integration)
                    setShowFacebookIntegrationDetails(true)
                } else {
                    navigate('/channels')
                }
            }
        } else {
            setFacebookIntegrationDetails(null)
            setShowFacebookIntegrationDetails(false)
        }
    }, [integrationListNewStructure])

    useEffect(() => {
        if(metaCredentials){
            const loadFacebookSDK = () => {
                let facebookConfig = metaCredentials?.find((configuration) => configuration.channel_name.toLowerCase() == "facebook")
                if (window.FB) {
                    console.log("FB SDK already loaded");
                    return;
                }

                window.fbAsyncInit = function () {
                    window.FB.init(facebookConfig?.fb_init);
                    console.log("facebookConfig", facebookConfig)
                    console.log("FB SDK initialized");
                };

                const script = document.createElement('script');
                script.async = true;
                script.defer = true;
                script.crossOrigin = 'anonymous';
                script.src = "https://connect.facebook.net/en_US/sdk.js";
                document.head.appendChild(script);
            };
            loadFacebookSDK();
        }
    }, [metaCredentials]);

    const loginToFacebook = () => {

        let facebookConfig = metaCredentials?.find((configuration) => configuration.channel_name.toLowerCase() == "facebook")

        if(!facebookConfig?.flag_can_integrate){
            setFlagIntegrationNotAvailablePopup(true);
            return;
        }

        window.FB.login((response: any) => {
            if (response.authResponse) {
                console.log("Welcome! Fetching your information....");
                window.FB.api("/me", (res: fbLoginResponse) => {
                    console.log("res 1:", res);
                    console.log("Good to see you, " + res.name + ".");
                    getPagesList();
                });
            } else {
                console.log("User cancelled login or did not fully authorize.");
            }
        }, { scope: FACEBOOK_LOGIN_SCOPE });
    };

    const getPagesList = () => {
        window.FB.api("/me/accounts", (result: getInstagramAccessTokenResponse) => {
            console.log("result: ", result);
            if (result && !result.error) {
                const pages: DataItem[] = result.data;
                if (pages.length) {
                    const transformedData = pages?.map((page: DataItem) => ({
                        access_token: page.access_token,
                        page_id: page.id,
                        page_name: page.name,
                        page_category: page.category,
                        page_categoryList: page.category_list.map((cat: Category) => ({
                            id: cat.id,
                            name: cat.name
                        }))
                    }));
                    setResponsePayload(transformedData)
                }
                else {
                    showError("No page was selected while integrating.")
                }
            }
            else {
                console.log("Error fetching page access token:", result.error);
            }
        });
    };

    const safeLogout = (): void => {
        // Check the user's current login status
        window.FB.getLoginStatus((response: any) => {
            if (response.status === 'connected') {
                // User is logged in to your app and Facebook.
                // It's safe to call logout
                window.FB.logout((logoutResponse: any) => {
                    console.log('User logged out successfully', logoutResponse);
                    // Handle post-logout logic here
                });
            } else {
                console.log('User was not logged in via Facebook SDK. No need to log out.');
                // Handle scenarios where the user was not logged in
            }
        });
    };
    useEffect(() => {
        (async () => {
            if (responsePayload && responsePayload.length > 0) {
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
                let metaIntegrationTypeId = globalIntegrationTypeList.find((type) => type.channel_name.toLowerCase() === "facebook")?.channel_id ?? Number(process.env.REACT_APP_FACEBOOK_META_INTEGRATION_TYPE_ID);

                if (!metaIntegrationTypeId) {
                    console.error("Meta Integration Type ID for Facebook is undefined");
                    return;
                }

                const facebookPayload: createMetaIntegrationPayloadNew = {
                    channel_id: metaIntegrationTypeId,
                    meta_integration_facebook_data: responsePayload?.map((page: responsePayloadInterface) => ({
                        page_id: page?.page_id,
                        page_name: page?.page_name,
                        page_category: page?.page_category,
                        access_token_value: page?.access_token,
                    })),
                    channel_authoriser_user_data: {
                        authoriser_unique_id: Number(responsePayload?.[0]?.page_id),
                        authoriser_unique_name: responsePayload?.[0]?.page_name,
                        authoriser_unique_email: "",
                    },
                    meta_data: JSON.stringify(responsePayload)
                };


                const response = await agent.createMetaIntegration.post(facebookPayload);
                if (response.status) {
                    onBoardUser(); // On Board User to the platform.
                    let responseNewStructure = response.data[0]
                    let whatsappIntegrations = responseNewStructure.meta_integration_whatsapp_data.map((integration: any) => {
                        return {
                            ...integration,
                            integrated_channel_id: integration.meta_integration_whatsapp_id,
                            channel_name: 'Whatsapp'
                        }
                    })
                    setIntegrationListNewStructure([...whatsappIntegrations, ...responseNewStructure.meta_integration_facebook_data, ...responseNewStructure.meta_integration_instagram_data
                    ])
                    let sortedData = responseNewStructure.meta_integration_facebook_data.sort((a: globalIntegration, b: globalIntegration) => new Date(b.created_at_timestamp).getTime() - new Date(a.created_at_timestamp).getTime())
                    setIntegrationList((prevState: any) => ([...prevState, ...response.data]))
                    showSuccess("Integration Successfull!")
                    navigate(`/channels/viewintegration/facebook?id=${sortedData[0].integrated_channel_id}`)
                    setFacebookIntegrationDetails(sortedData[0])
                    setShowFacebookIntegrationDetails(true)
                }
                else {
                    let errorCode = checkForErrorCode(response)
                    if (response.message == "canceled") {
                    }
                    else {
                        handleError(response);
                    }
                    safeLogout()
                }
                setResponsePayload(null);
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))

            }
        })();
    }, [responsePayload]); 

    const innerHeight = smallScreen ? (window.innerHeight - 90) : tabletScreen ? (window.innerHeight - 100) : laptopScreen ? (window.innerHeight - 100) : (window.innerHeight - 110);
    const integrationViewInnerHeight = smallScreen ? (window.innerHeight - 110) : tabletScreen ? (window.innerHeight - 100) : laptopScreen ? (window.innerHeight - 120) : (window.innerHeight - 140);

    return (
        <>
            <Grid item
                className={showFacebookIntegrationDetails == false ? `${globalStyles.fullwidth} ${styles.integrationDefaultView}` : `${globalStyles.fullwidth} ${styles.integrationView}`}
                height={showFacebookIntegrationDetails == false ? `${innerHeight}px !important` : `${integrationViewInnerHeight}px !important`}
            >
                <Grid container>
                    {showFacebookIntegrationDetails == false &&
                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={`${globalStyles.trySampleChatbotContainer} ${globalStyles.containerFlexWrap}`}  gap={"13px"}  flexDirection={{ xs: "row-reverse", md: "row" }}>
                                <Grid item className={styles.integrationContent}>
                                    <img alt="" src={messengerIcon} className={styles.whatsappIntegrationIcon} />
                                </Grid>
                                <Grid item>
                                    <Grid container  className={globalStyles.flexColumn} gap={{ xs: "8px", md: "4px" }}>
                                        <Grid item>
                                            <Typography className={globalStyles.whatsappIntegrationFontStyle}>Facebook Integration</Typography>
                                        </Grid>
                                        <Grid item>
                                            <span className={globalStyles.whatsappIntegrationSubFontStyle}>Integrate AI Chatbot into your Facebook Business account to boost customer engagement and efficiency.</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    }

                    {(showFacebookIntegrationDetails) ?
                        <>
                            <Grid item className={globalStyles.fullwidth} xs={12} lg={12} xl={12}>
                                <Grid container className={globalStyles.flexColumn} gap={3}  >
                                    <FacebookIntegationDetails flagPage={props.flagPage} />
                                </Grid>
                            </Grid>
                        </>
                        :
                        <>
                            {showFacebookIntegrationDetails == false &&
                                <Grid item className={globalStyles.fullwidth} xs={12} lg={8} xl={6} mt={4}>
                                    <Grid container  pt={1} className={`${styles.integrationWorking} ${globalStyles.flexColumn} ${globalStyles.gapTwo} ${globalStyles.containerFlexWrap}`}>
                                        <Grid item>
                                            <Grid container className={`${globalStyles.containerflexWrapStyle} ${globalStyles.spaceAlignmentCenter} ${globalStyles.gapOne}` } >
                                                <Grid item>
                                                    <span className={globalStyles.whatsappIntegrationFontStyle}>Prerequisites for Facebook Integration</span>
                                                </Grid>
                                                <Grid item className={styles.workingIconStyle}>
                                                    <IconsColor iconName="ideaIcon" height={"30"} width={"30"} />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <ChatbotFacebookIntegrationSetup
                                            launch={loginToFacebook}
                                            viewIntegration={true}
                                        />
                                    </Grid>
                                    <Grid container>
                                        <Grid item className={`${styles.integrateGridStyles} ${styles.blockMargin}`}>
                                            <Grid container>
                                                <Grid item xs={12} >
                                                    <GlobalButton
                                                        buttonText={"Integrate Now"}
                                                        className="primaryButtonStyle"
                                                        disabled={!hasChannelsManageAccess(apiRoutesPermissionAssignment, userDetail)}
                                                        onClick={() => {
                                                            loginToFacebook()
                                                        }}
                                                        sx={{ padding: "6px 20px !important" }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>}
                        </>
                    }
                </Grid>
            </Grid>

        </>
    )
}

export default ViewFacebookIntegration